import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {PositionModel} from '@/libs/Api';
import {PositionsDataService} from '@/libs/positions/positions-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const positionsStore = registerCrudStore<PositionModel, PositionModel>(BusinessModule.Position, new PositionsDataService());
